var EditButton = /** @class */ (function () {
    function EditButton(button) {
        var parent = button;
        do {
            parent = parent.parentElement;
        } while (parent != null && !parent.classList.contains('subscription-entry'));
        this.body = parent.querySelector('.subscription-entry-body');
        button.addEventListener('click', this.onButtonClick.bind(this));
    }
    EditButton.prototype.onButtonClick = function () {
        var _a;
        (_a = this.body) === null || _a === void 0 ? void 0 : _a.classList.toggle('hidden');
    };
    return EditButton;
}());
export default EditButton;
